<template>
  <b-modal id="bv-modal-change-password"
           size="lg"
           :ok-only="true"
           :ok-title="tr('changePassword.update','Update password')"
           @ok="save"
           :no-close-on-esc="true"
           :no-close-on-backdrop="true"
           :hide-header-close="true"
           ref="modal"
  >
    <template v-slot:modal-title>
      {{tr('changePassword.must.changed','Your password must be changed.')}}
    </template>

    <b-container>
      <b-form v-on:keydown.enter="enterTrigger">
        <reach-input
        :label="tr('changePassword.enter.new.password','Enter a new password')"
        :help-title="tr('password','Password')"
        :help-message="passwordHelp"
        :formField="form.password"
        :hint="tr('changePassword.info.characters','Min 6 characters; mix at least two of: capital/small/number/special character')"
        type="password"
        :initial-focus="true"
        >
        </reach-input>
        <reach-input
            :label="tr('changePassword.repeat.new','Repeat a new password')"
            :help-title="tr('changePassword.repeat','Repeat password')"
            :help-message="tr('changePassword.need.match','Both passwords need to match')"
            :formField="form.password2"
            :hint="tr('changePassword.both.need.match','Both passwords need to match')"
            type="password"
        >
        </reach-input>
      </b-form>
    </b-container>

    <template #modal-footer="{close}">
      <b-container class="pl-0">
        <b-row >
          <b-col
              :class="samePasswordFeedback !== '' ? 'pt-2' : ''"
              class="col-12 col-lg-9 text-center" v-if="samePasswordFeedback !== ''">
            <label class="text-danger">{{samePasswordFeedback}}</label>
          </b-col>
          <b-col
              :class="samePasswordFeedback === '' ? 'col-lg-12' : 'col-lg-3'"
              class="col-12 text-center text-sm-right">
            <b-button
                :disabled="!form.canSubmit || !matchedPasswords"
                variant="plm-save"
                @click="save"
            >{{tr('changePassword.update','Update password')}}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>

  </b-modal>
</template>



<script>
import VBox from "@/components/VBox";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import ChangePasswordForm from "@/components/users/ChangePasswordForm";
import ReachInput from "@/components/inputs/ReachInput";
import DashboardUserForm from "@/components/users/DashboardUserForm";
import tr from "@/utils/Tr";


export default {
  name: "ChangePasswordDialog",
  components: {VBox, ReachInput},

  mounted(){
    this.form.validate();
  },

  watch: {
    'form.password.value': function (val) {
      this.matchedPasswords = (this.form.password.value === this.form.password2.value
          && (this.form.password.value.length >= 6
          && this.form.password2.value.length >= 6
          ));
    },
    'form.password2.value': function (val) {
      this.matchedPasswords = (this.form.password.value === this.form.password2.value
          && (this.form.password.value.length >= 6
              && this.form.password2.value.length >= 6
          ));
    },
  },

  methods: {
    tr,


    async enterTrigger(event) {
      if (this.form.canSubmit) {
        await this.save();
      }
    },

    async save(){
      let result = await Rpc.Users.isPasswordIsDifferent(this.form.password.value);
      if(!result){
        this.samePasswordFeedback = tr('changePassword.message','The new password must be different from the current one.');
      }
      else{
        try {
          await this.form.saveUser();
          this.$refs.modal.hide();
        }
        catch (e) {
          this.form.parseException(e);
        }
      }
    },

  },
  data: () => ({
    form: new ChangePasswordForm(),
    user: SessionManager.isAdmin ? null : new ApplicationUser(),
    mode: "NEW",
    matchedPasswords: false,
    samePasswordFeedback: "",
    passwordHelp:
        `<div> Min 6 characters; <br> Mix at least two of: <br>
                <ul style="display: inline-block">
                    <li>capital</li>
                    <li>small</li>
                    <li>number</li>
                    <li>special char</li>
                </ul>
           </div>`
  })
}
</script>
